import React from 'react'
import { fileSystemUrl, videoUrl } from '../../constants/Connections'
import { useUser } from '../../auth'

/** The image or video attached to a task. Images open in the shared image viewer. */
export default function ArchiveMedia({ files, title, openImageBig }) {
    const { user } = useUser()
    if (!files?.storage_name) return null

    const isVideo = files.type === 'video'
    const url = `${isVideo ? videoUrl : fileSystemUrl}/${files.storage_name}?token=${user.token}`

    if (isVideo) {
        return (
            <div className="archive-media">
                <video controls controlsList="nodownload" preload="metadata">
                    <source src={url} />
                </video>
            </div>
        )
    }

    return (
        <button type="button" className="archive-media archive-media--image" onClick={() => openImageBig(url)} aria-label={title}>
            <img src={`${url}&width=450`} alt={title || ''} loading="lazy" />
        </button>
    )
}
